// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  // urlapi: 'http://crmpro.des/api/',
  // urlimages: 'http://crmpro.des',
  //urlapi: 'http://192.168.100.22/api/',
  //urlapi: 'http://192.168.19.200/api/',
  //urlimages: 'http://192.168.19.200'
  urlapi: 'https://dev-roburlatam.sisconde.com.mx/api/',
  urlimages: 'https://dev-roburlatam.sisconde.com.mx/'
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
